import {
  Box,
  Card,
  Flex,
  Separator,
  Text,
  Theme,
  Dialog,
} from 'components/ds'

import React, { Component } from 'react'
import type { Track } from 'types/track'
import HelpTooltip from 'components/common/tooltip'
import Button from 'components/ui/button'

type Props = {
  track: Track
  isOpen?: boolean
  onClose: (...args: Array<any>) => any
  onAddFormat: (...args: Array<any>) => any
  onReplaceFormat: (...args: Array<any>) => any
  onDeleteFormat: (...args: Array<any>) => any
}

export default class ManageTrackFormats extends Component<Props> {
  _onAddFormat: () => void = () => {
    this.props.onAddFormat()
  }

  _shouldDeleteBeDisabledForFormat(format: string): boolean {
    const formatIsOptimised = ['mp3', 'm4a', 'mp4'].includes(format)
    const allFormats = Object.keys(this.props.track.all_files || {})
    return allFormats.length > 1 && formatIsOptimised
  }

  _renderFormat(format: string): React.ReactElement {
    return (
      <Card key={format} mb="3" size="2">
        <Flex align="center" justify="between">
          <Text size="3" weight="regular">
            {format}
          </Text>
          <Flex gap="3">
            <Box width="100px">
              <Button
                caption="Delete"
                onClick={() => this.props.onDeleteFormat(format)}
                disabled={this._shouldDeleteBeDisabledForFormat(format)}
                fullWidth
              />
            </Box>
            <Box width="100px">
              <Button
                appearance="black"
                caption="Replace"
                onClick={() => this.props.onReplaceFormat(format)}
                fullWidth
                />
            </Box>
          </Flex>
        </Flex>
      </Card>
    )
  }

  render(): React.ReactNode {
    const { track, isOpen = true, onClose } = this.props
    const formats = Object.keys(this.props.track.all_files || {})

    return (
      <Dialog.Root open={isOpen} onOpenChange={onClose}>
        <Dialog.Content maxWidth="600px" aria-describedby={undefined}>
          <Theme>
            <Box>
              <Box mb="6">
                <Dialog.Title>
                  <Flex align="center" gap="2">
                    Manage formats for {track.name}
                    <HelpTooltip id="tooltip_manage_formats" />
                  </Flex>
                </Dialog.Title>
                <Text size="2" color="gray">
                  {track.artist}
                </Text>
              </Box>

              <Box>{formats.map(format => this._renderFormat(format))}</Box>

              <Separator size="4" my="4" />

              <Flex justify="between" align="center">
                <Button
                  appearance="link"
                  caption="+ Add format"
                  onClick={this.props.onAddFormat}
                  disabled={formats.length > 1}
                />
                <Dialog.Close>
                  <Button
                    appearance="subtle"
                    caption="Close"
                  />
                </Dialog.Close>
              </Flex>
            </Box>
          </Theme>
        </Dialog.Content>
      </Dialog.Root>
    )
  }
}
